import React from 'react'
import { Label } from 'irmlib/components/Controls'
import { openGeneralDialog } from 'irmlib/containers'
import styled from 'styled-components'

import LoginBody, { Buttons } from './Body'

const LoginTitle = styled(Label)`
  font-size: 16px;
`

const doLogin = () => {
  const callOpen = () => {
    openGeneralDialog({ onCancel: () => { callOpen() }, primaryTitle: true, title: <LoginTitle>login.loginTitle</LoginTitle>, message: <LoginBody />, buttons: <Buttons />, closeX: false })
  }
  callOpen()
}

export default doLogin